// Data wygenerowania w aktywnym języku (reguła 31) — jedno wywołanie na ekran.
//
// `locales/generatedAt.ts` jest czystą funkcją (bez Reacta i bez `t()`), bo to samo
// robi `format.ts` i z tego samego powodu: da się ją przetestować dla dowolnego
// „teraz”. Ten hook dokłada do niej dwa słowa z locale i aktywny język, żeby ekran
// nie musiał ich podawać przy każdym wierszu.

import { useCallback } from 'react'
import { generatedAt } from '../locales/generatedAt'
import { useI18n, useT } from '../lib/i18n'

/** `(iso) => 'dziś 14:20'` albo `null`, gdy rzecz nie ma jeszcze daty. */
export function useGeneratedAt(): (iso: string | null | undefined) => string | null {
  const { locale } = useI18n()
  const t = useT()
  return useCallback(
    (iso) => generatedAt(locale, iso, { today: t('series.dateToday'), yesterday: t('series.dateYesterday') }),
    [locale, t],
  )
}

export default useGeneratedAt
